import { Routes, Route, Navigate } from 'react-router-dom';
import ClientLayout from './components/ClientLayout';
import Home from './pages/Home';
import Catalogo from './pages/Catalogo';
import Produto from './pages/Produto';
import Carrinho from './pages/Carrinho';
import Checkout from './pages/Checkout';
import Promocoes from './pages/Promocoes';
import Conjuntos from './pages/Conjuntos';
import MobilePushInitializer from '@/shared/components/MobilePushInitializer';

function ClientApp() {
  return (
    <ClientLayout>
      {/* Inicializar sistema de notificações push mobile apenas no cliente */}
      <MobilePushInitializer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/produto/:id" element={<Produto />} />
        <Route path="/carrinho" element={<Carrinho />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/promocoes" element={<Promocoes />} />
        <Route path="/conjuntos" element={<Conjuntos />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ClientLayout>
  );
}

export default ClientApp;

